<template>
  <div v-if="productData && !unavailableProduct && !cartLimitForProductReached && productData.isleaseable" :style="showCard ? 'display:block' : 'display:none'">
    <slot name="borderline"/>
    <div class="col-12 quick-v-tocart buy-now">
      <adv-cart-button
        class="addToCart"
        :unavailable="unavailableProduct || cartLimitForProductReached"
        :cart-limit-reached="cartLimitForProductReached"
        :has-attributes="hasAttributes"
        :selected-attribute-id="selectedAttributeId"
        v-on:btn-click="addToCard"
        :stock="productCodeData.productStock"
        :progress="progress"
        :productId="productId"
        :is-buy-now="isBuyNow"
        v-bind:quantity="quantity"></adv-cart-button>
      <slot name="static"/>
    </div>
  </div>
</template>

<script>
import { some } from 'lodash'
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import AdvCartButton from './AdvCartButton'

export default {
  name: 'AdvProductCardBuyNow',
  components: {
    AdvCartButton
  },
  props: {
    productId: {
      type: Number
    }
  },
  mixins: [productMixin],
  data () {
    return {
      version: '0.0.2',
      productCodeId: null,
      quantity: 1,
      showCard: true,
      progress: false,
      mainImage: {
        is_main: '1',
        original: store.state.noImage,
        small: store.state.noImage,
        medium: store.state.noImage,
        large: store.state.noImage
      }
    }
  },
  mounted () {
    this.setProductCodeIdForOneOnOne()
  },
  watch: {
    productId () {
      this.setProductCodeIdForOneOnOne()
    }
  },
  computed: {
    config () {
      return store.getters.config
    },
    isBuyNow () {
      return true
    },
    hasAttributes () {
      return some(this.productData.productCodes, (e) => {
        return e.productCodeAttributes.length > 0
      })
    },
    unavailableProduct () {
      return this.productCodeData.productStock <= 0 || this.productData.productFinalPrice <= 0
    },
    cartLimitForProductReached () {
      return this.productCodeData.productStock === this.cartQuantity
    },
    selectedAttributeId () {
      return parseFloat(store.getters.getSelectedAttributeId)
    },
    cartQuantity () {
      return this.$store.getters.cartProductCodeQuantity(this.productCodeId, 0)
    },
  },
  methods: {
    setProductCodeIdForOneOnOne () {
      if (!this.hasAttributes) {
        this.codeIdChanged(this.productData.productCodes[0].productCodeId)
        return
      }
      this.quantity = 1
    },
    codeIdChanged (productCodeId) {
      this.productCodeId = productCodeId
      if (this.productCodeId) {
        store.dispatch('setSelectedProductCodeId', this.productCodeId)
      }
    },
    addToCard () {
      if (this.isBuyNow && this.productData.isleaseable) {
        window.location.assign(this.productData.leaseUrl)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.buy-now {
  width: 100%;
  padding: 1rem;
  background: #ededed;
}
.product-main-wrapper .quick-v-tocart {
  @media screen and (min-width: 576px) and (max-width: 767px) {
    max-width: 100%;
  }
}
</style>
